<template>
  <FullModal ref="FullModal" @close="close">
    <div class="details" v-loading="loadingContainer">
      <LableContent label="基本信息">
        <template #btn>
          <el-button
            type="primary"
            size="mini"
            @click="handleBringInPofeData"
            style="margin-left: 10px"
          >
            带入概算数据
          </el-button>
          <el-button
            type="primary"
            size="mini"
            @click="handlePushToProject"
            style="margin-left: 10px"
          >
            推送给协同单位
          </el-button>
        </template>
        <div class="header-content">
          <div class="base-info">
            <div
              v-for="(item, index) in form"
              :key="index"
              class="base-info-item"
            >
              <div class="label">{{ item.label }}</div>
              <div class="value">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </LableContent>
      <EstimateDetail
        ref="estimateDetail"
        :basicInfo="basicInfo"
        v-if="basicInfo.id"
      />
    </div>
  </FullModal>
</template>

<script>
import FullModal from '@/components/FullModal/index.vue'
import LableContent from '@/components/LableContent/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import EstimateDetail from './EstimateDetail.vue'

import {
  sortRecords,
  handleImport,
  addCbFn,
  aggregationSUM,
  aggregationAmount,
  preViewFile
} from '@/utils/index'

export default {
  name: 'DesignDetail',
  components: { FullModal, LableContent, SimpleTable, EstimateDetail },
  provide() {
    return {
      detailsVm: this
    }
  },
  data() {
    return {
      basicInfo: {},
      form: [],
      columns: {
        fl: [{ field: 'name', title: '工程分类', widht: 100 }],
        top: [
          {
            title: '单项工程',
            field: 'name',
            aggregation: aggregationSUM
          },
          {
            title: '计量单位',
            field: 'measurementUnit'
          },
          {
            title: '建设规模',
            field: 'constructionScale',
            aggregation: aggregationAmount
          },
          {
            title: '汇总项',
            field: 'summaryFlag',
            cellType: ({ col, row, table }) => {
              return table.getCellOriginRecord(col, row) ? 'checkbox' : 'text'
            },
            multiple: false
          },
          {
            title: '工程分类',
            field: 'engineeringClassifyName',
            editModal: {
              columns: [{ field: 'name', title: '工程分类', tree: true }],
              options: async () => {
                const res = await this.$service.get(
                  '/engineering-classify/listAllClassify',
                  {}
                )
                return sortRecords(res?.data || [])
              },
              confirm: (selectedCellInfos, res) => {
                const row = res[0][0].originData
                selectedCellInfos.forEach(cells => {
                  const obj = cells[0].originData
                  this.$set(obj, 'engineeringClassifyName', row.name)
                  this.$set(obj, 'engineeringClassifyId', row.id)
                })
              }
            }
          },
          {
            title: '所在地区',
            field: 'regionName',
            editModal: {
              columns: [{ field: 'name', title: '所在地区' }],
              options: async () => {
                const res = await this.$service.get('/region/list', {})
                return sortRecords(res?.data || [])
              },
              confirm: (selectedCellInfos, res) => {
                const row = res[0][0].originData
                selectedCellInfos.forEach(cells => {
                  const obj = cells[0].originData
                  this.$set(obj, 'regionName', row.name)
                  this.$set(obj, 'regionId', row.id)
                })
              }
            }
          },
          {
            title: '详细地址',
            field: 'address'
          }
        ],
        left: [
          {
            title: '工程特征',
            field: 'name'
          },
          {
            title: '特征值',
            field: 'featureValue'
          }
        ],
        center: [
          {
            title: '工程参数',
            field: 'name'
          },
          {
            title: '参数值',
            field: 'paramValue',
            fieldType: 'number'
          }
        ],
        right: [
          {
            title: '文件名',
            field: 'name',
            cellType: 'link'
          },
          { title: '后缀', field: 'suffix' },
          { title: '锁号', field: '' },
          { title: '联系人', field: '' },
          { title: '上传时间', field: 'sysCreatedDate' }
        ]
      },
      tableData: {
        top: [],
        fl: [],
        left: [],
        center: [],
        right: []
      },
      loading: {
        top: false,
        fl: false,
        left: false,
        center: false,
        right: false
      },
      currentSelect: {
        top: null,
        fl: null,
        left: null,
        center: null,
        right: null
      },
      loadingContainer: false
    }
  },
  methods: {
    // 页面方法
    show(row) {
      this.currentSelect = {
        top: null,
        fl: null,
        left: null,
        center: null,
        right: null
      }

      this.getBaseInfo(row.id)
      // .then(() => this.getTableData())
      this.$refs.FullModal.show({
        width: '100%',
        height: '100%',
        showConfirm: false,
        title: null,
        fullscreen: true,
        closeOnPressEscape: false
      })
    },
    close() {
      this.$emit('close')
    },

    async getBaseInfo(id) {
      const res = await this.$service.get(
        '/construction-budget-estimate/detail/' + id
      )
      this.basicInfo = sortRecords(res?.data || {})
      this.form = [
        { label: '预算名称', value: this.basicInfo.name },
        { label: '设计概算', value: this.basicInfo.dbeName },
        { label: '项目名称', value: this.basicInfo.projectName },
        { label: '所在地区', value: this.basicInfo.regionName },
        { label: '详细地址', value: this.basicInfo.address },
        { label: '计量单位', value: this.basicInfo.measurementUnit },
        { label: '建设规模', value: this.basicInfo.constructionScale },

        { label: '造价指标', value: this.basicInfo.costIndicator },
        { label: '盈亏平衡点', value: this.basicInfo.breakEvenPoint },
        { label: '盈利周期', value: this.basicInfo.profitCycle },
        // { label: '加密锁号', value: this.basicInfo.profitCycle },
        { label: '编制单位', value: this.basicInfo.createdUnitName },
        { label: '编制日期', value: this.basicInfo.sysCreatedDate }
      ]
    },

    // 带入概算数据
    async handleBringInPofeData() {
      const res = await this.$service.post(
        '/construction-budget-estimate/import-estimate/' + this.basicInfo.id
      )
      if (res.code === 200) {
        this.$message.success('带入成功')
        this.$refs.estimateDetail.init()
      }
    },

    // 推送给协同单位  打开弹窗
    async handlePushToProject() {
      const options = await this.getProjectList()
      this.$selectModal({
        title: '推送给协同单位',
        columns: [
          { field: 'unitName', title: '单位名称' },
          { field: 'unitType', title: '单位类型' },
          { field: 'projectName', title: '项目名称' },
          { field: 'regionName', title: '所在地区' }
        ],
        options,
        allowMultiSelect: false,
        width: '800px',
        confirm: (selectedCellInfos, res) => {
          const arr = selectedCellInfos.map(e => e[0].originData)
          if (!arr.length) return this.$message.warning('请选择一条数据')
          this.submitToProject(arr[0])
        }
      })
    },

    // 获取甲方列表
    async getProjectList() {
      const res = await this.$service.get('/project/pushable-list', {})
      return sortRecords(res?.data || [])
    },

    // 发送给甲方
    async submitToProject(obj) {
      const res = await this.$service.post('/common/push-estimate', {
        projectId: obj.projectId,
        unitId: obj.unitId,
        mainId: this.basicInfo.id
      })
      if (res.code === 200) {
        this.$message.success('推送成功')
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style scoped lang="less">
.details {
  padding-top: 10px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > ::v-deep .container {
    height: unset;
  }
  .header-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    gap: 40px;
    padding-right: 20px;
    .left {
      flex: 1;
    }
    .right {
      cursor: pointer;
    }
  }
  .base-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 16px;
    width: 100%;
    .base-info-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 32%;
      color: #000;
      &:nth-child(3n -1) {
        margin: 0 2%;
      }
      .label {
        width: 142px;
        text-align: right;
        margin-right: 16px;
      }
      .value {
        height: 32px;
        flex: 1;
        background-color: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 6px;
        border: 1px solid #2a7ca7;
      }
    }
  }
  .detail-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    ::v-deep .label-content {
      width: 100%;
    }
    ::v-deep .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 10px;
      height: 700px;
      > div {
        flex: 1;
        width: 100%;
        height: 33%;
      }
      > .center {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px;
        > div {
          flex: 1;
        }
      }
      .bottom {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px;
      }
    }
  }
}
</style>
